const languages = [
	{
		value: 'en',
		label: 'English',
		icon: '/assets/flags/uk.png',
	},
	{
		value: 'fr',
		label: 'Français',
		icon: '/assets/flags/fr.png',
	},
	{
		value: 'es',
		label: 'Español',
		icon: '/assets/flags/es.png',
	},
	{
		value: 'de',
		label: 'Deutsch',
		icon: '/assets/flags/gr.png',
	},
	{
		value: 'it',
		label: 'Italiano',
		icon: '/assets/flags/it.png',
	},
	{
		value: 'pt',
		label: 'Português',
		icon: '/assets/flags/br.png',
	},
	{
		value: 'nl',
		label: 'Dutch',
		icon: '/assets/flags/nl.png',
	},
	{
		value: 'tr',
		label: 'Türkçe',
		icon: '/assets/flags/tu.png',
	},
	{
		value: 'ru',
		label: 'русский',
		icon: '/assets/flags/ru.png',
	},
	{
		value: 'ko',
		label: '한국어',
		icon: '/assets/flags/kr.png',
	},
	{
		value: 'ja',
		label: '日本語',
		icon: '/assets/flags/jp.png',
	},
	{
		value: 'zh',
		label: '中文',
		icon: '/assets/flags/cn.png',
	},
	{
		value: 'id',
		label: 'Bahasa Indonesia',
		icon: '/assets/flags/id.png',
	},
	{
		value: 'vi',
		label: 'Tiếng Việt',
		icon: '/assets/flags/vi.png',
	},
	{
		value: 'fa',
		label: 'فارسی',
		icon: '/assets/flags/ir.png',
	},
	{
		value: 'ar',
		label: 'العربية',
		icon: '/assets/flags/uae.png',
	},
];

export default languages;
